<template>
	<div class="slidemenu-container titlemenu-phone">
        <div>
		<swiper :options="mySwiperOption" class="contanter-box">
			<swiper-slide v-for="(item,index) in menulist" :key="index" :class="pid == item.id ? 'active slide' : 'slide' ">
				<!-- <img :src="httpImageUrl" width="100%" @click="onClick(i)"/> -->
                <span class="slidemenu-line0" @click="onClick(item)"> {{item.title}}</span> <span class="slidemenu-line1">|</span>
			</swiper-slide>
			<swiper-slide class="swiper-slide slide">
                <a :href="outsidelink" style="color:#666666" target="_blank">郝斯特新闻</a>
			</swiper-slide>
		
			<!-- <div class="swiper-pagination" slot="pagination"></div> -->
		</swiper>
        </div>
	</div>
</template>
 
<script>
	// 局部引入 vue-awesome-swiper 及其样式
	import {	swiper,swiperSlide} from 'vue-awesome-swiper'
	import configration from '@/tools/js/enumconfig'
	//import 'swiper/dist/css/swiper.css'
	export default {
		name: 'SlideMenu',
		components: {
			// 注册 vue-awesome-swiper 组件
			swiper,
			swiperSlide
		},
        props:{
            menulist: Array,
			pid:String
        },
		data() {
			return {
				mySwiperOption: {
                    slidesPerView: 3,
                    freeMode:true,
					//自动播放
					autoplay: false,
                    loop: false,
                    spaceBetween : 1,
                    observer: true,
                    observeParents: true,
				},
				outsidelink:configration.config.enum.news_outside_link,
                
			}
		},
		methods:{
			onClick:function(t){
				this.$router.push({path:'/news/list',query:{pid:t.id,fid:t.parentId}});
			}
		}
	}
</script>

<style scoped>
.contanter-box{
    width: 100%;
    height: 24px;
    /* background-color: bisque; */
}
.slide{
    text-align: left;
    width: auto !important;
    height: 24px;
	margin-left: 20px;
    /* background-color: cadetblue; */
}
.slide:first-child  {margin-left: 0;}
.slidemenu-line1 {margin-left: 16px;}


.slidemenu-container .swiper-wrapper .active .slidemenu-line0 {font-size: 14px;
    background-color: white;
    color: #083286;
    font-weight: bold;
    }


</style>
 